<div [class]="'mat-option-chips-container ' + customClass">
  @if (!isSimpleText) {
    <div class="mat-option-chips">
      @for (item of getSelectedItems; track $index) {
        <div class="mat-option-chip">
          @if (item.Image) {
            <img [src]="item.Image" class="chip-icon border-radius-10" [alt]="item.Name" />
          }
          <span class="chip-copy">{{ item.Name }}</span>
          @if (isDeletable) {
            <mat-icon class="chip-icon" (click)="onDelete(item, $event)">close</mat-icon>
          }
        </div>
      }
    </div>
  } @else {
    @for (item of getSelectedItems; track $index) {
      @if (item.Image) {
        <img [src]="item.Image" class="chip-icon border-radius-10" [alt]="item.Name" />
      }
      <span class="mat-option-value">{{ item.Name }}</span>
    }
  }
</div>
